export const properties = {
    RESOURCE_VALIDACION:'validacion',
    REGISTRAR_CREDENCIAL: 'registrar-credencial',
    TIPO_CREDENCIAL: "fa",
};